<div class="row">


    <div class="col-12" style="height:65vh !important; overflow: auto;">
      <form [formGroup]="PowerUserRoleStatusForm">
        <div class="row pt-1">
          <div class="col-12">
           <div class="row">


        <div class="col-12">


            <div class="row pt-1">
              <div class="col-2 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <div class="p-0">Power User #</div>
                  </div>

              </div>
              <div class="col-2 pt-1 px-1">
                <input type="text" [attr.disabled]="true" formControlName="powerUserId" readonly="readonly"  class="form-control form-control-sm input-txtbox"/>
              </div>
              <div class="col-8 pt-1 px-1">
                <div class="d-flex">
                  <div class="px-2">
                    <div class="p-0">From Status</div>


                  </div>
                  <div class="px-1">
                    <div class="p-0">
                        <input type="text" formControlName="status" [attr.disabled]="true" readonly="readonly"  class="form-control form-control-sm input-txtbox"/>
                    </div>
                  </div>
                  <div class="px-1">

                    <div class="p-0">To Status</div>



                  </div>
                  <div class="px-0">
                     <div class="p-0 label-red">*</div>
                  </div>
                  <div class="px-1">
                    <div class="p-0">
                        <select  class="form-control form-control-sm input-txtbox"  (change)="UpdateStatus($event)">
                            <option selected value="0" hidden></option>
                            <option class="border-bottom" *ngFor="let role of Statusdetails" [value]="role.Power_User_Role_Status_Type_Code">{{role.Power_User_Role_Status_Type_Code}}</option>
                          </select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="col-2 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <div class="p-0">From Status</div>
                  </div>

              </div>
              <div class="col-2 pt-1 px-1">
                <input type="text" readonly="readonly"  class="form-control form-control-sm input-txtbox"/>
              </div>
              <div class="col-2 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <div class="p-0">To Status</div>
                  </div>

              </div>
              <div class="col-2 pt-1 px-1">
                <input type="text" readonly="readonly"  class="form-control form-control-sm input-txtbox"/>
              </div> -->
            </div>
            <div class="row pt-1">
              <div class="col-2 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <!-- <div class="p-0 label-red">*</div>          -->
                  <div class="p-0">Name</div>
                  </div>

              </div>
              <div class="col-10 pt-1 px-1">
                <input type="text" [attr.disabled]="true" formControlName="name" readonly="readonly"  class="form-control form-control-sm input-txt"/>
              </div>
            </div>
            <div class="row pt-1">
              <div class="col-2 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <!-- <div class="p-0 label-red">*</div>          -->
                  <div class="p-0">Role</div>
                  </div>

              </div>
              <div class="col-10 pt-1 px-1">
                <select  class="form-control form-control-sm input-txt" [attr.disabled]="true" (change)="onSelectRole($event)" formControlName="selectRole">

                    <option class="border-bottom" [disabled]="true" *ngFor="let role of this.roles" value="{{role.Code}}">{{role.Name}}</option>
                  </select>
              </div>
            </div>
            <div class="row pt-1">
              <div class="col-2 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <!-- <div class="p-0 label-red">*</div>          -->
                  <div class="p-0">Start date</div>
                  </div>

              </div>
              <div class="col-10 pt-1 px-1">
                <input type="text"   formControlName="startDate" [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1"
                class="form-control form-control-sm input-txt" (ngModelChange)="compareStartDates()" >
              <owl-date-time  [pickerType]="'calendar'" #dt1></owl-date-time>
              </div>
              <div class="col-2"></div>
           <div class="col-10 pt-1 px-1"><label  class="Valid1"  *ngIf="error1.isError">{{error1.errorMessage}}</label>
              </div>

            </div>
            <div class="row pt-1">
              <div class="col-2 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <!-- <div class="p-0 label-red">*</div>          -->
                  <div class="p-0">End date</div>
                  </div>

              </div>
              <div class="col-10 pt-1 px-1">
                <input type="text"  formControlName="endDate"   [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2"
                class="form-control form-control-sm input-txt" (ngModelChange)="compareEndDates()">
              <owl-date-time  [pickerType]="'calendar'" #dt2></owl-date-time>
              </div>
              <div class="col-2"></div>
              <div class="col-10 pt-1 px-1"><label  class="Valid1" *ngIf="error.isError">{{ error.errorMessage }}</label></div>
            </div>



            <div class="row pt-1">
              <div class="col-2 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">
                  <div class="p-0 label-red" *ngIf="ToStatus!='Approved'">*</div>
                  <div class="p-0">Comments/Notes</div>
                  </div>

              </div>
              <div class="col-10 pt-1 px-1">
                <textarea  maxlength="4000" formControlName="comments" class="form-control input-txt1"
                ></textarea>
              </div>
            </div>




           <div class="row pt-3 pb-1">
            <div class="col-2">


            </div>
            <div class="col-10 pt-1 px-1">
              <div class="d-flex">
                <div class="px-1">
                <button type="submit"  class="btn btn-sm bl-btn" [disabled] = "PowerUserRoleStatusForm.invalid||(ToStatus!='Approved'&&!PowerUserRoleStatusForm.value.comments)||(!ToStatus)" (click)="OnClickSaveButton()" >Confirm</button>
                </div>
                <div class="px-1">
                  <button type="button"   class="btn btn-sm bg-light border" (click) = "OnClickCancelButton()">Cancel</button>
                </div>
              </div>
            </div>
          </div>


              </div>






<!--
          <div class="col-4">

            <div class="row pt-1">
              <div class="col-4 text-right  pt-1 pl-1 pr-0">
                <div class="d-flex flex-row-reverse">

                  <div class="p-0">User Status</div>
                  </div>

              </div>
              <div class="col-8 pt-1 px-1">
                <input type="text" readonly="readonly" formControlName="status" class="form-control form-control-sm input-txt11"/>
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-4">


              </div>
              <div class="col-8 pt-1 px-1">
                <div class="d-flex">
                  <div class="px-1">

                  <button type="submit"  class="btn btn-sm bg-light border">Change Status</button>
                  </div>



                </div>
              </div>
            </div>

          </div> -->
        </div>

        </div>
          </div>
      </form>
    </div>
  </div>
